module.exports = __webpack_public_path__ + "img/ong.dd4423ad.svg";